export default from './MobileMenu';



// WEBPACK FOOTER //
// ./src/layouts/AppLayout/components/Menu/components/MobileMenu/index.js